import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import Loader from "../components/Loader";
import { getChatList, setChatList } from "../localDb/personal_chat";
import Api from "../service/http";
import { useSocket } from "../service/SocketProvider";
import PersonalChatList from "./chat/PersonalChatList";

const PersonalChats = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [chatLists, setchatLists] = useState([]);
  const [listReady, setListReady] = useState(false);

  const { socket, subscribe, unsubscribe } = useSocket();
  const [typingChat, setTypingChat] = useState([]);
  const controlTyping = (chatId, typing) => {
    if (typing) {
      setTypingChat((prevTypingChat) => {
        const ids = prevTypingChat.map((item) => item?.id);
        if (!ids.includes(chatId)) {
          return [
            ...prevTypingChat,
            { id: chatId, time: new Date().getTime() },
          ];
        }
        return prevTypingChat;
      });
    } else {
      setTypingChat((prevTypingChat) =>
        prevTypingChat.filter((item) => item?.id !== chatId)
      );
    }
  };

  setTimeout(() => {
    setTypingChat((prevTypingChat) =>
      prevTypingChat.filter((item) => new Date().getTime() - item?.time < 3000)
    );
  }, 3000);

  useEffect(() => {
    const handleMessage = (data) => {
      switch (data.type) {
        case "WebMeesageTyping":
          if (data.chat_id) {
            controlTyping(data?.chat_id, data.typing);
          }
          break;

        case "WebFetchMessage":
          getChatListFromServer();
          break;
        case "WebFetchChat":
          getChatListFromServer();
          break;
        default:
          break;
      }
    };
    if (socket) subscribe(handleMessage);
    return () => unsubscribe(handleMessage);
  }, [socket, subscribe, unsubscribe]);

  const getChatListFromServer = async () => {
    const response = await Api.get("/web/chats?chat_type=PR");
    if (response.data?.data) {
      setChatList(response.data?.data);
      setchatLists(response.data?.data);
    }
    return response.data?.data || [];
  };

  const syncChatList = async () => {
    const chatList = getChatList();
    setchatLists(chatList);
    if (chatList?.length > 0) {
      navigate(`/personal-chat/${chatList[0]?.id || ""}`);
      await getChatListFromServer();
    } else {
      const res = await getChatListFromServer();
      if (res?.length > 0) {
        navigate(`/personal-chat/${res[0]?.id}`);
      }
    }
    setListReady(true);
  };

  useEffect(() => {
    syncChatList();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- initial load only
  }, []);

  return (
    <div className="flex-1 h-full overflow-hidden">
      {!listReady ? (
        <Loader className="m-auto" />
      ) : (
        <div className="flex h-full w-full">
          <div className={`${id ? "hidden md:flex" : "flex w-full md:w-auto"}`}>
            <PersonalChatList
              chats={chatLists}
              typingChat={typingChat}
              onListsRefresh={getChatListFromServer}
            />
          </div>
          <div className={`flex-1 flex flex-col min-w-0 h-full overflow-hidden ${!id ? "hidden md:flex" : "flex"}`}>
            {chatLists?.length > 0 ? (
              <Outlet />
            ) : (
              <div className="flex-1 flex items-center justify-center text-gray-500 text-sm px-6 text-center">
                No personal chats yet. Search for a user in the sidebar to start
                one.
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PersonalChats;
